import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaShip, FaTruck, FaUsers, FaArrowRight } from 'react-icons/fa';

const Services = () => {
  const services = [
    {
      icon: <FaShip className="text-4xl text-primary mb-4" />,
      title: "Importation",
      description: "Gestion complète de l'importation de vos produits au Canada, incluant la conformité aux réglementations locales.",
      link: "/services"
    },
    {
      icon: <FaTruck className="text-4xl text-primary mb-4" />,
      title: "Distribution",
      description: "Réseau logistique efficient couvrant plus de 158 points de vente à travers le Québec et l'Ontario.",
      link: "/services"
    },
    {
      icon: <FaUsers className="text-4xl text-primary mb-4" />,
      title: "Représentation",
      description: "Représentation de votre marque auprès des principales chaînes de distribution canadiennes.",
      link: "/services"
    }
  ];

  return (
    <section className="section">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="section-title">Nos Services</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Solutions complètes pour développer votre présence sur le marché canadien
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-8 rounded-lg shadow-md flex flex-col h-full"
            >
              <div className="flex justify-center mb-3">
                {service.icon}
              </div>
              <h3 className="text-2xl font-bold mb-3 text-center">{service.title}</h3>
              <p className="text-gray-600 mb-6 text-center flex-grow">{service.description}</p>
              <Link 
                to={service.link} 
                className="flex items-center justify-center mt-auto text-primary font-medium group"
              >
                En savoir plus
                <FaArrowRight className="ml-2 transition-transform group-hover:translate-x-1" />
              </Link>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link to="/services" className="btn-primary inline-block">
            Voir tous nos services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Services; 